module.exports = __webpack_public_path__ + "img/2.f113a3ff.webp";